export default __webpack_public_path__ + "static/media/save-energy.1d7396ba.png";